import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { memo, useCallback, useContext, useMemo } from "react";
import { createG11nMemoryStore, GlobalizationProvider, LocaleService, LocaleServiceGlobalizationSettings } from "@jutro/locale";
import { isTSMEnabled } from "./tsm/tsmHelpers";
import { tsmMessageLoader } from "./tsm/tsmMessageLoader";
import { GlobalizationMessages } from "./GlobalizationMessages";
import { GlobalizedHead } from "./GlobalizedHead";
import { LanguagesLoader } from "./LanguagesLoader";
import { MessagesContext } from "./MessagesContext";
var tsmLoaders = [tsmMessageLoader];
var GlobalizedContentInternal = function (_ref2) {
  var globalizationSettings = _ref2.globalizationSettings,
    appName = _ref2.appName,
    messageLoader = _ref2.messageLoader,
    coreMessageLoader = _ref2.coreMessageLoader,
    intlTextComponent = _ref2.intlTextComponent,
    _ref2$persistToLocalS = _ref2.persistToLocalStorage,
    persistToLocalStorage = void 0 === _ref2$persistToLocalS || _ref2$persistToLocalS,
    _ref2$persistToURL = _ref2.persistToURL,
    persistToURL = void 0 !== _ref2$persistToURL && _ref2$persistToURL,
    children = _ref2.children,
    storeProp = _ref2.store,
    useG11nStore = _ref2.useG11nStore || !!storeProp;
  useG11nStore && null === LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE && (LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE = !0);
  var _useContext = useContext(MessagesContext),
    _useContext$messagesS = _useContext.messagesState,
    messages = _useContext$messagesS.messages,
    isMessagesLoaded = _useContext$messagesS.isMessagesLoaded,
    messagesDispatch = _useContext.messagesDispatch,
    onLoadMessages = useCallback(function (newMessages) {
      return messagesDispatch({
        type: "messagesLoaded",
        payload: newMessages
      });
    }, [messagesDispatch]),
    loaders = useMemo(function () {
      return [coreMessageLoader, messageLoader];
    }, [coreMessageLoader, messageLoader]),
    legacyProps = function (_ref) {
      var globalizationSettingsProp = _ref.globalizationSettings,
        _ref$persistToLocalSt = _ref.persistToLocalStorage,
        persistToLocalStorage = void 0 === _ref$persistToLocalSt || _ref$persistToLocalSt,
        _ref$persistToURL = _ref.persistToURL,
        persistToURL = void 0 !== _ref$persistToURL && _ref$persistToURL,
        useG11nStore = _ref.useG11nStore,
        globalizationSettings = useMemo(function () {
          return useG11nStore ? void 0 : globalizationSettingsProp || new LocaleServiceGlobalizationSettings({
            skipLocalStoragePersistence: !persistToLocalStorage,
            skipURLPersistence: !persistToURL
          });
        }, [globalizationSettingsProp, persistToURL, persistToLocalStorage, useG11nStore]),
        _useMemo = useMemo(function () {
          return globalizationSettings ? {
            onLanguageOrLocaleChange: function (change) {
              var _globalizationSetting;
              return null === (_globalizationSetting = globalizationSettings.onGlobalizationChange) || void 0 === _globalizationSetting ? void 0 : _globalizationSetting.call(globalizationSettings, change);
            },
            onLocaleChange: function (locale) {
              var _globalizationSetting2;
              return null === (_globalizationSetting2 = globalizationSettings.onGlobalizationChange) || void 0 === _globalizationSetting2 ? void 0 : _globalizationSetting2.call(globalizationSettings, {
                locale: locale,
                localeChanged: !0
              });
            },
            onLanguageChange: function (language) {
              var _globalizationSetting3;
              return null === (_globalizationSetting3 = globalizationSettings.onGlobalizationChange) || void 0 === _globalizationSetting3 ? void 0 : _globalizationSetting3.call(globalizationSettings, {
                language: language,
                languageChanged: !0
              });
            }
          } : {};
        }, [globalizationSettings]),
        onLanguageOrLocaleChange = _useMemo.onLanguageOrLocaleChange,
        onLocaleChange = _useMemo.onLocaleChange,
        onLanguageChange = _useMemo.onLanguageChange;
      return useG11nStore || !globalizationSettings ? {} : {
        defaultLocale: globalizationSettings.getPreferredLocale(),
        defaultLanguage: globalizationSettings.getPreferredLanguage(),
        availableLanguages: globalizationSettings.getAvailableLanguages(),
        availableLocales: globalizationSettings.getAvailableLocales(),
        defaultCountryCode: globalizationSettings.getDefaultCountryCode(),
        defaultCurrency: globalizationSettings.getDefaultCurrency(),
        defaultTimeZone: globalizationSettings.getDefaultTimeZone(),
        onLanguageOrLocaleChange: onLanguageOrLocaleChange,
        onLocaleChange: onLocaleChange,
        onLanguageChange: onLanguageChange
      };
    }({
      globalizationSettings: globalizationSettings,
      persistToLocalStorage: persistToLocalStorage,
      persistToURL: persistToURL,
      useG11nStore: useG11nStore
    }),
    g11nStore = useMemo(function () {
      return storeProp || (useG11nStore ? createG11nMemoryStore() : void 0);
    }, [storeProp, useG11nStore]);
  return React.createElement(GlobalizationProvider, _extends({
    messages: messages,
    store: g11nStore
  }, legacyProps, {
    intlTextComponent: intlTextComponent
  }), React.createElement(GlobalizationMessages, {
    loaders: loaders,
    onLoad: onLoadMessages
  }), isMessagesLoaded && React.createElement(GlobalizedHead, {
    appName: appName
  }), children);
};
GlobalizedContentInternal.displayName = "GlobalizedContent";
export var GlobalizedContent = memo(GlobalizedContentInternal);
var AuthGlobalizedContent = function () {
  var messagesDispatch = useContext(MessagesContext).messagesDispatch,
    onLoadLanguages = useCallback(function () {
      return messagesDispatch({
        type: "languagesLoaded"
      });
    }, [messagesDispatch]),
    onLoadMessagesTSM = useCallback(function (newMessages) {
      return messagesDispatch({
        type: "messagesLoadedTSM",
        payload: newMessages
      });
    }, [messagesDispatch]);
  return React.createElement(React.Fragment, null, isTSMEnabled() && React.createElement(GlobalizationMessages, {
    loaders: tsmLoaders,
    onLoad: onLoadMessagesTSM
  }), React.createElement(LanguagesLoader, {
    onLoad: onLoadLanguages
  }));
};
AuthGlobalizedContent.displayName = "AuthenticatedGlobalizedContent";
export var AuthenticatedGlobalizedContent = memo(AuthGlobalizedContent);
GlobalizedContentInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "GlobalizedContent",
  props: {
    persistToLocalStorage: {
      defaultValue: {
        value: "true",
        computed: !1
      },
      required: !1
    },
    persistToURL: {
      defaultValue: {
        value: "false",
        computed: !1
      },
      required: !1
    }
  }
}, AuthGlobalizedContent.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AuthenticatedGlobalizedContent"
}, GlobalizedContentInternal.__docgenInfo = {
  componentName: "GlobalizedContent",
  packageName: "@jutro/app",
  description: "",
  displayName: "GlobalizedContent",
  methods: [],
  actualName: "GlobalizedContentInternal",
  props: {
    persistToLocalStorage: {
      defaultValue: {
        value: "true",
        computed: !1
      },
      required: !1
    },
    persistToURL: {
      defaultValue: {
        value: "false",
        computed: !1
      },
      required: !1
    }
  }
}, AuthGlobalizedContent.__docgenInfo = {
  componentName: "AuthenticatedGlobalizedContent",
  packageName: "@jutro/app",
  description: "",
  displayName: "AuthenticatedGlobalizedContent",
  methods: [],
  actualName: "AuthGlobalizedContent"
};